import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import { type Account } from "./use-connected-accounts-query";

type Params = {
  type: "google" | "icloud";
  email?: string | null;
  label?: string | null;
  instructions?: string | null;
  app_specific_password?: string | null;
  scopes?: string[] | null;
};

export const useEditAccountMutation = () => {
  const queryClient = useQueryClient();
  const fetch = useAuthFetch();

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/connected-account`,
        {
          method: "PATCH",
          body: JSON.stringify({
            ...params,
          }),
        }
      );

      const data: { connected_accounts: Account[]; id: string } =
        await response.json();

      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["api", "connected-accounts"],
      });
    },
  });
};
